<template lang="pug">
  #resize_heatmap_btn
    .text-center.mt-4(v-if="!$store.state.heatmap.show_resize_heatmap")
      label.mr-1 高さ
      input.mr-2(type="number" v-model="pageHeight" style="width: 80px;")
      | px
      span.ml-2.mr-2
        button.btn.btn-success.btn-xs(@click="saveHeight") 決定
        button.btn.btn-default.btn-xs.ml-4(@click="editHeight") 編集
        help-tooltip(html-key='heatmapResize')
</template>

<script>
import VueResizable from 'vue-resizable'

import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  props: {
    token: String
  },
  methods: {
    editHeight(e){
      e.preventDefault()
      this.$store.commit( "heatmap/setPreviewPageHeight", this.$store.state.heatmap.page_height )
      this.$store.commit("heatmap/setShowResizeHeatmap", true)
    },
    async saveHeight(e){
      this.$store.commit( "heatmap/setPageHeight", this.$store.state.heatmap.page_height )
      location.href = `/users/heatmaps/${this.token}/edit_page_height?height=${this.$store.state.heatmap.page_height}&device=${this.$store.state.heatmap.device}`
    }
  },
  async mounted(){
    await Vue.nextTick()
  },
  computed: {
    pageHeight: {
      get() {
        return this.$store.state.heatmap.page_height
      },
      set(value) {
        this.$store.commit("heatmap/setPageHeight", value)
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
